import gql from 'graphql-tag';

export const DUPLICATE_OR_USE_EXISTING = gql`
  mutation DuplicateOrUseExistingPost($articleId: Int!, $postIds: [String!]!, $action: PostActionEnum!) {
    duplicateOrUseExistingPost(articleId: $articleId, postIds: $postIds, action: $action) {
      creatives {
        id
        postId
      }
      errors
    }
  }
`;
